<template>
  <div class="feed-list-wrap">
    <feed-status @currentChangeStatus="setPage"/>
    <ul class="feed-list-view">
      <li class="feed-list-view__item" v-for="(item, idx) in views" :key="idx">
        <i :class="`material-icons md18 ${item.active ? 'color_main' : 'color_gray'}`" @click="switchView">
          {{item.icon}}
        </i>
      </li>
    </ul>
  </div>
</template>

<script>
  // components
  import FeedStatus from './FeedStatus';

  // vuex
  import { mapGetters } from 'vuex';

  // store
  import { TOGGLE_FEED_LIST_VIEW } from '../store/actions/common'

  export default {
    name: "feedListView",
    computed: {
      ...mapGetters([
        'listView',
      ]),
      views() {
        return {
          panel: {
            icon: 'view_quilt',
            active: !this.listView
          },
          list: {
            icon: 'list',
            active: this.listView
          },
        }
      }
    },
    methods: {
    setPage(value) {
      this.$emit("currentPageStatus", value);
    },
      switchView() {
        this.$store.dispatch(TOGGLE_FEED_LIST_VIEW);
      }
    },
    components: {
      FeedStatus
    }
  };
</script>

<style>
  .feed-list-wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #E4E7ED;
    margin-bottom: 15px;
    padding-bottom: 10px;
  }
  .feed-list-view {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: flex-end;
  }
  .feed-list-view__item {
    cursor: pointer;
    margin-left: 8px;
  }
</style>
